import * as React from 'react';
import { SVGProps } from 'react';

const IconPhotoSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2zm.5 7h7L7 4.5 5 7 4 6 2.5 8z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default IconPhotoSizeXs;
